import { render } from "./BirthGuideList.vue?vue&type=template&id=b685bb36"
import script from "./BirthGuideList.vue?vue&type=script&lang=js"
export * from "./BirthGuideList.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__